export let skipLinkControlButtonAriaLabel = "Bh4R5d";
export default {skipLinkControlButtonAriaLabel};